module.exports = __webpack_public_path__ + "img/young-women-computer.6062c3a2.png";